<template>
	<div class="project" v-if="projectData">
		<project-name
			v-model="projectData.title"
			:readonly="true"
		></project-name>
		<ProjectReadOnlyHeader :project-data="projectData" :requested-dotation="requestedDotation"/>
		<BidderNameReadOnlyView :view-data="projectData"/>
		<project-costs-calculated-table
			class="mt-3"
			:actions="projectData.actionsData"
			:costs="projectData.actionsCosts"
			:administrative="projectData.administrativeCosts"
			ref="costsCalculatedTable-1"
			:remove-page-break="true"
		/>
	</div>
</template>

<script>
	import ProjectName from "./components/ProjectName";
	import ProjectReadOnlyHeader from "./ProjectReadOnlyHeader";
	import {Project} from "@/api/generated/Project";
	import {Api} from "@/api";
	import BidderNameReadOnlyView from "../offer/components/ReadOnlyComponents/BidderNameReadOnlyView";
  import ProjectCostsCalculatedTable from "@/view/logged/project/components/ProjectCostsCalculatedTable";

	export default {
		name: "ProjectReadOnlyBudgetView",
		components: {ProjectCostsCalculatedTable, BidderNameReadOnlyView, ProjectReadOnlyHeader, ProjectName},

		data () {
			return {
				projectData: null,
			};
		},

		created () {
			this.loadData();
		},

		methods: {
			async loadData () {
				Project.getRequestedDotation(this, this.$route.params.projectId, successResponse => {
						this.requestedDotation = successResponse.requestedDotation;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować wnioskowanej kwoty dotacji", errorResponse);
					});

				// Pobranie danych projektu
				let path;
				if (this.$route.params.version) {
					path = "/project/data-version?projectId=".concat(this.$route.params.projectId).concat("&version=".concat(this.$route.params.version));
				} else {
					path = "/project/readonly?projectId=".concat(this.$route.params.projectId);
				}
				await Api.syncGet(
					this,
					path,
					response => {
						this.projectData = response;
					});
			},
		}
	};
</script>

<style scoped>

</style>